import {observer} from "mobx-react"
import {FieldAutoComplete, FieldInput, FieldSelect} from "../../ui"
import {convertWeighingType} from "../../../api";
import {WeighingTypeDto} from "../../../api/kpi";
import {FieldDate} from "@kroschke/react-ui";
import {KpiCustomerItem, kpiCustomerStore} from "../../../store";
import {toNumberString} from "../../../utils";


export interface WeighingCreateFormData {
    amount: string
    date: string
    type: WeighingTypeDto
    customer?: KpiCustomerItem
}

interface WeighingCreateFormProps {
    data: WeighingCreateFormData
    disabled: boolean
    valid: boolean
    onChange: (value: WeighingCreateFormData) => any
    validate: () => Promise<void>
    create: () => Promise<any>
    help: WeighingCreateFormHelp
}

interface WeighingCreateFormHelp {
    customerId?: string,
    amount?: string,
    date?: string,
    type?: string,
}


const weighingTypeOptions = Object.keys(WeighingTypeDto).map(e => ({
    value: e,
    label: convertWeighingType(e as WeighingTypeDto)
}))




const WeighingCreateForm = observer(function WeighingCreateForm({
                                                                    data,
                                                                    valid,
                                                                    disabled,
                                                                    onChange,
                                                                    validate,
    create,
                                                                    help
                                                                }: WeighingCreateFormProps) {

    const now = new Date()
    const minDate = new Date()
    minDate.setDate(minDate.getDate() - 7)

    const maxDateValue = now.toISOString().split('T')[0]
    const minDateValue = minDate.toISOString().split('T')[0]

    return <>
        <div style={{
            display: 'flex'
        }}>
            <div style={{
                flex: '1'
            }}>
                <div className={"columns"}>
                    <div className={"column is-one-quarter"}>
                        <FieldInput
                            label={"Gewicht (kg)"}
                            disabled={disabled}
                            required={true}
                            invalid={Boolean(help.amount)}
                            help={help.amount}
                            inputTransform={(v) => toNumberString(v)}
                            value={data.amount}
                            onBlur={async () => await validate()}
                            onChange={amount => {
                                onChange({
                                    ...data,
                                    amount
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-quarter"}>
                        <FieldSelect
                            label={"Erfassungstyp"}
                            disabled={disabled}
                            required={true}
                            invalid={Boolean(help.type)}
                            help={help.type}
                            options={weighingTypeOptions}
                            value={data.type}
                            onBlur={async () => await validate()}
                            onChange={type => {
                                onChange({
                                    ...data,
                                    type: type as WeighingTypeDto
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-quarter"}>
                        <FieldDate
                            label={"Datum"}
                            disabled={disabled}
                            required={true}
                            invalid={Boolean(help.date)}
                            help={help.date}
                            min={minDateValue}
                            max={maxDateValue}
                            value={data.date}
                            onBlur={async () => await validate()}
                            onChange={date => {
                                onChange({
                                    ...data,
                                    date
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-quarter"}>
                        <FieldAutoComplete
                            label={"Kunde"}
                            value={data.customer}
                            options={kpiCustomerStore.items}
                            itemRenderer={c => c.label || c.id}
                            search={v => kpiCustomerStore.search(v)}
                            onChange={async (customer: KpiCustomerItem | undefined) => {
                                onChange({
                                    ...data,
                                    customer
                                })
                                await validate()
                            }}
                        />
                    </div>
                </div>
            </div>
            <div style={{
                paddingLeft: '1em',
                paddingTop: '0.25em'
            }}>
                <button
                    className={"button is-primary"}
                    disabled={!valid}
                    onClick={async () => await create()}
                >Hinzufügen</button>
            </div>
        </div>
    </>
})

export {
    WeighingCreateForm
}
